<template>
  <div class="page-container">
    <div class="page-title">
      {{ $t('data.payin_transaction') }}
    </div>
    <PayinTransDetails />
  </div>
</template>

<script>
export default {
  name: 'Data_Payin',
  components: {
    PayinTransDetails: () => import('./components/PayinTransDetails.vue')
  }
}
</script>

<style scoped>
.page-container{
  margin: 40px 57px 50px 32px;
}
.page-container .page-title{
  padding-bottom: 24px;
  border-bottom: 1px solid #D3D7DF;
}
</style>
